import type { FC } from 'react';
import React from 'react';

import type { Filter } from 'Types/filter';

import { ChipSelect } from '../../ChipSelect';

import type { ChipFilterConfig } from './AllFiltersContent.consts';
import { getChipSelected } from './AllFiltersContent.helpers';

interface ChipSectionProps {
	config: ChipFilterConfig;
	filters: Filter;
	onSelect: (selected: string[]) => void;
}

export const ChipSection: FC<ChipSectionProps> = ({ config, filters, onSelect }) => (
	<ChipSelect onSelect={onSelect} options={config.options} selected={getChipSelected(config, filters)} />
);
